/**
 * Created by neo on 23.12.22.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { OnlineMeetingEntry } from '../../../Model/Explore/OnlineMeetingEntry';
import { useLocalized } from '../../../Hooks/useLocalized';
import styled from '@emotion/styled';
import { MarkdownRenderer } from '../../Markdown/MarkdownRenderer';
import { Theme } from '../../../Theme/Theme';

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Title = styled.h1`
  font-size: 1.75rem;
  font-weight: 700;
  color: ${Theme.Colors.textColor};
  margin: 0;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const GradientLine = styled.div`
  width: min(200px, 40%);
  height: 4px;
  border-radius: 4px;
  background: ${Theme.Colors.primary};
`;

const Description = styled.div`
  font-size: 1rem;
  line-height: 1.7;
  color: ${Theme.Colors.charcoal};

  p {
    margin: 0 0 16px 0;

    &:last-child {
      margin-bottom: 0;
    }
  }

  a {
    color: ${Theme.Colors.primary};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export type ExploreContentViewOnlineMeetingContentProps = {
  entry: OnlineMeetingEntry;
};

export const ExploreContentViewOnlineMeetingContent: React.FC<ExploreContentViewOnlineMeetingContentProps> = observer(
  ({ entry }) => {
    const title = useLocalized(entry.name);
    const content = useLocalized(entry.description);

    return (
      <ContentContainer>
        <TitleContainer>
          <Title>{title}</Title>
          <GradientLine />
        </TitleContainer>
        <Description>
          <MarkdownRenderer text={content} />
        </Description>
      </ContentContainer>
    );
  },
);
